import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent {
  @Input() isOpen = false;
  @Input() showCloseButton = true;
  @Output() closeMenu = new EventEmitter<void>();

  handleCloseMenu() {
    this.isOpen = false;
    this.closeMenu.emit();
  }
}
